/* eslint-disable react-hooks/exhaustive-deps */
import React, { MouseEventHandler, useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CustomToolTip from "../../core/CustomToolTip/CustomToolTip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as InfoIcon } from '../../assets/images/info.svg'

import './PriceCalculator.css';
import { formatNumber, numberRegex } from "../../utils/helpers";
import { useVideo } from "../../context/VideoContext";
import { Country } from './PriceCalculator.types';
import CircularLoading from "../../shared/CircularLoading/CircularLoading";
import { getApiSubRegionRegionName, postApiTaricTaricAdValorenDTN, getApiDailyParamName } from '../../api/interconectar-api'
import IconError from "../Icons/IconError";
import IconPro from "../Icons/IconPro";
import { PaisesDestino } from "./PaisesDestino";
import { useAuth } from "../../context/AuthContext";
import { useRemainingCalculations } from "../../hooks/useRemainingCalculations";
import { Tooltip } from "@mui/material";
import truckTypeOptions from "./truckTypeOptions.json";



const PriceCalculatorStepThree = ({ handleClickOpen, handleContinueClick }:{  handleClickOpen: MouseEventHandler<HTMLDivElement>, handleContinueClick: () => void }) => {
    const { t, i18n } = useTranslation();
    const { state } = useAuth();
    const { data: remainingCalcs, loading: loadingCalcs, error: errorCalcs } =  useRemainingCalculations( process.env.REACT_APP_PRICE_CALCULATOR_ID || '37');
    const { setVideoName } = useVideo();
    const [formThreeValues, setFormThreeValues] = useState<any>();
    const [newCountries, setCountries] = useState<any[]>([]);
    const [loadingCountries, setLoadingCountries] = useState<boolean>(true);
    const [errorCountries, setErrorCountries] = useState<string | null>(null);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [loadingTaric, setLoadingTaric] = useState<boolean>(true);
    const [loadingGastoAduanero, setLoadingGastoAduanero] = useState<boolean>(false);

    const formTwo = JSON.parse(window.localStorage.getItem("formTwo")!);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const onSubmit = (data: any) => {
        localStorage.setItem("formThree", JSON.stringify(data));
        setFormThreeValues(data);
        handleContinueClick();
    };

    useEffect(() => {
        const formThree = localStorage.getItem("formThree")
            ? JSON.parse(localStorage.getItem("formThree")!)
            : "";
        if (Object.keys(formThree).length) {
            
            // Si tenemos countryDestinationId pero no countryDestinationName, intentamos establecerlo
            if (formThree.countryDestinationId && !formThree.countryDestinationName) {
                // Buscar el nombre del país basado en el ID
                let countryName = "";
                newCountries.forEach((region) => {
                    const foundCountry = region.countries.find((country: Country) => country.id === formThree.countryDestinationId);
                    if (foundCountry) {
                        countryName = foundCountry.name;
                    }
                });
                
                if (countryName) {
                    formThree.countryDestinationName = countryName;
                }
            }
            
            // Asegurarse de que importerTruckType tenga un valor válido
            if (formThree.importerTruckType) {
                // Verificar si el valor existe en truckTypeOptions (case-insensitive)
                const truckTypeKeys = Object.keys(truckTypeOptions[0]);
                const truckTypeExists = truckTypeKeys.some(key => 
                    key.toLowerCase() === formThree.importerTruckType.toLowerCase()
                );
                
                if (!truckTypeExists) {
                    // Establecer un valor por defecto si no es válido
                    formThree.importerTruckType = truckTypeKeys[0];
                } else {
                    // Si existe pero con diferente case, actualizar al valor correcto del objeto
                    const correctKey = truckTypeKeys.find(key => 
                        key.toLowerCase() === formThree.importerTruckType.toLowerCase()
                    );
                    if (correctKey && correctKey !== formThree.importerTruckType) {

                        formThree.importerTruckType = correctKey;
                    }
                }
            }
            
            setFormThreeValues(formThree);
        }
    }, [newCountries]); // Añadimos newCountries como dependencia para que se ejecute cuando los países estén cargados

    useEffect(() => {
        if (formThreeValues) {
            
            reset(formThreeValues);
        }
    }, [formThreeValues, reset]);

    useEffect(() => {
        formTwo.conveyance === "maritimo" || formTwo.conveyance === "multimodal"
            ? setVideoName("thirdBarcoVideo")
            : formTwo.conveyance === "aereo"
            ? setVideoName("thirdAvionVideo")
            : setVideoName("");
    }, []);

    

    useEffect(() => {
        const fetchCountries = async () => {
            
            try {
                
                // Llamada a la API con la región "Europa"
                const data = await getApiSubRegionRegionName("Europa");

                const storedData = JSON.parse(localStorage.getItem("formOne") || "{}");
                const excludedId = storedData?.countryOriginId;

                if (data.results) {
                    const filteredCountries = data.results.map((region: any) => ({
                        ...region,
                        countries: region.countries.filter(
                            (country: any) => country.id !== excludedId
                        ),
                    }));

                    setCountries(filteredCountries);
                }
                
            } catch (error) {
                setErrorCountries(t('price_calculator.step_3.error_message_fetch'));
            } finally {
                setLoadingCountries(false);
            }
        };

        fetchCountries();
    }, []);

    useEffect(() => {
        setLoadingTaric(true);
        if (!state?.isAuthenticated || !remainingCalcs) {
			setLoadingTaric(false);
			return;
		}
        
        if (remainingCalcs?.remaining === 0 || remainingCalcs?.remaining == null) {
            setLoadingTaric(false);
            return;
		}
        
        const fetchTaricData = async () => {
            
            try {
                const formOne = JSON.parse(localStorage.getItem("formOne") || "{}");
                const response = await postApiTaricTaricAdValorenDTN({
                    countryOriginCode: formOne?.originCode,
                    goodsCode: formOne?.tarifCode
                });
                
                if (response.result) {
                    setFormThreeValues((prev: Record<string, any>) => ({
                        ...prev,
                        adValoremTax: response.result?.adValoren,
                        taxDeterminedByWeight: response.result?.dtn
                    }));
                }
            } catch (error) {
                // console.error('Error fetching Taric data:', error);

                setFormThreeValues((prev: Record<string, any>) => ({
                    ...prev,
                    adValoremTax: 0,
                    taxDeterminedByWeight: 0
                }));
            } finally {
                setLoadingTaric(false);
            }
        };

        fetchTaricData();
        
    }, [remainingCalcs]);

    useEffect(() => {
        if (state?.isAuthenticated && remainingCalcs && remainingCalcs.remaining > 0 && !formThreeValues?.customersExpensesValueUsd) {
            setLoadingGastoAduanero(true);
            getApiDailyParamName("GastoAduanero")
                .then((response) => {
                    if (response.result?.value) {
                        setFormThreeValues((prev: Record<string, any>) => ({
                            ...prev,
                            customersExpensesValueUsd: response.result?.value
                        }));
                    }
                })
                .catch((error) => {
                    console.error('Error fetching GastoAduanero:', error);
                })
                .finally(() => {
                    setLoadingGastoAduanero(false);
                });
        }
    }, [state?.isAuthenticated, remainingCalcs, formThreeValues?.customersExpensesValueUsd]);

    useEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, []);

    if (loadingCountries || loadingTaric || loadingGastoAduanero) {
        return <CircularLoading />;
    }

    if (errorCountries) {

        return <div className='errorcalculator'>
			<div className='errorcalculator__icon'>
				<IconError />	
			</div>			
			<p className='errorcalculator__txt'>{errorCountries}</p>
		</div>;
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="exporter-test__read-only">
                <div className='price-calculator__container-main'>
                    <div className="price-calculator___inner">
                        <div className="container price-calculator___container">
                            <div className="row">
                                <div className='col-12'>
                                    <span className='price-calculator__container-title'>{t('price_calculator.step_3.subtitle')}</span>
                                </div>
                            </div>

                            <div className="row price-calculator__row mb-4">
                                <div className='col-12 col-sm-12 col-md-6'>
                                    <div className='price-calculator__field-with-icon label-container container_input__pro'>
                                        <label className="label-input">{t('price_calculator.step_3.portExpensesUsd.placeholder')}</label>
                                        
                                            <input
                                                type="text"
                                                className="price-calculator__textbox-general-col2"
                                                {...register('portExpensesUsd', { required: true })}
                                                value={!!formThreeValues?.portExpensesUsd ? formThreeValues?.portExpensesUsd : ''}
                                                onChange={ (e) => {
                                                    if (e.target.value === '' || numberRegex.test(e.target.value)) {
                                                        setFormThreeValues({...formThreeValues, portExpensesUsd: formatNumber(e.target.value)})
                                                    }
                                                }}
                                            />

                                        <div style={{ marginLeft: "8px"}}>
                                            <CustomToolTip
                                                title=""
                                                tooltipText={t('price_calculator.step_3.portExpensesUsd.tooltip')}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faCircleQuestion}
                                                    className="font-size: 18px"
                                                />
                                            </CustomToolTip>
                                        </div>
                                    </div>
                                    <div className="label__pro">
                                        <IconPro width={13} height={10} fill='#BBC2C7' />
                                        {t('price_calculator.label_pro.description')}
                                    </div>
                                    {!!errors?.portExpensesUsd && 
                                        <div className="error-container">
                                            <InfoIcon fill="#F8A0D2" />
                                            <div className="error-message">{t('price_calculator.step_3.error_message')}</div>
                                        </div>
                                    }
                                </div>
                                <div className='col-12 col-sm-12 col-md-6'>
                                    <div className='price-calculator__field-with-icon label-container container_input__pro'>
                                        <label className="label-input">{t('price_calculator.step_3.customersExpensesValueUsd.placeholder')}</label>
                                        <input
                                            type="text"
                                            className="price-calculator__textbox-general-col2"
                                            value={!!formThreeValues?.customersExpensesValueUsd ? formThreeValues?.customersExpensesValueUsd : ''}
                                            {...register('customersExpensesValueUsd', { required: true })}
                                            onChange={ (e) => {
                                                if (e.target.value === '' || numberRegex.test(e.target.value)) {
                                                    setFormThreeValues({...formThreeValues, customersExpensesValueUsd: formatNumber(e.target.value)})
                                                }
                                            }}
                                        />
                                        <div style={{ marginLeft: "8px"}}>
                                            <CustomToolTip
                                                title=""
                                                tooltipText={t('price_calculator.step_3.customersExpensesValueUsd.tooltip')}
                                            >
                                            <FontAwesomeIcon
                                                icon={faCircleQuestion}
                                                className="font-size: 18px"
                                            />
                                            </CustomToolTip>
                                        </div>
                                    </div>
                                    <div className="label__pro">
                                        <IconPro width={13} height={10} fill='#BBC2C7' />
                                        {t('price_calculator.label_pro.description')}
                                    </div>
                                    {!!errors?.customersExpensesValueUsd && 
                                        <div className="error-container">
                                            <InfoIcon fill="#F8A0D2" />
                                            <div className="error-message">{t('price_calculator.step_3.error_message')}</div>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className='row price-calculator__row mb-4'>
                                <div className='col-12 col-sm-12 col-md-6'>
                                    <div className='price-calculator__field-with-icon'>
                                   
                                    <select
                                            {...register('countryDestinationId', { required: true })}
                                            value={formThreeValues?.countryDestinationId || ''} // Valor controlado del select
                                            onChange={(e) => {
                                                const selectedCountryId = e.target.value;

                                                // Buscar el país dentro de `newCountries`
                                                let selectedCountryName = "";
                                                newCountries.forEach((region) => {
                                                    const foundCountry = region.countries.find((country: Country) => country.id === selectedCountryId);
                                                    if (foundCountry) {
                                                        selectedCountryName = foundCountry.name;
                                                    }
                                                });

                                                setFormThreeValues({
                                                ...formThreeValues,
                                                countryDestinationId: selectedCountryId, 
                                                countryDestinationName: selectedCountryName,
                                                country: selectedCountryId,
                                                countryOriginId: selectedCountryId,
												paisSelect: '',
                                                });
                                            }}
                                            className="price-calc__dropdown-general price-calculator__select-font"
                                            >
                                            <option value="" disabled>
                                                {t('price_calculator.step_3.countryDestinationId.placeholder')}
                                            </option>
                                            
                                            {newCountries.map((region) => (
                                            <optgroup key={region.nameEs} label={region.nameEs}>
                                                {region.countries.map((country: Country) => (
                                                <option
                                                    key={country.id}
                                                    value={country.id}
                                                    className="price-calculator__select-font"
                                                >
                                                    {country.name}
                                                </option>
                                                ))}
                                            </optgroup>
                                            ))}
                                            
                                        </select>
                                        <div style={{ marginLeft: "8px"}}>
                                            <CustomToolTip
                                                title=""
                                                tooltipText={t('price_calculator.step_3.countryDestinationId.tooltip')}
                                            >
                                            <FontAwesomeIcon
                                                icon={faCircleQuestion}
                                                className="font-size: 18px"
                                            />
                                            </CustomToolTip>
                                        </div>
                                    </div>
                                    {!!errors?.countryDestinationId && 
                                        <div className="error-container">
                                            <InfoIcon fill="#F8A0D2" />
                                            <div className="error-message">{t('price_calculator.step_3.error_message')}</div>
                                        </div>
                                    }
                                </div>
                                <div className='col-12 col-md-3 label-container container_input__pro'>
                                    <label className="label-input">{t('price_calculator.step_3.adValoremTax.placeholder')}</label>
                                   
                                        <input
                                            type="text"
                                            className="price-calculator__textbox-general-col2"
                                            {...register('adValoremTax', { required: true })}
                                            value={!!formThreeValues?.adValoremTax ? formThreeValues?.adValoremTax : ''}
                                            onChange={ (e) => {
                                                if (e.target.value === '' || numberRegex.test(e.target.value)) {
                                                    setFormThreeValues({...formThreeValues, adValoremTax: formatNumber(e.target.value)})
                                                }
                                            }}
                                        />
                                    
                                    <div className="label__pro">
                                        <IconPro width={13} height={10} fill='#BBC2C7' />
                                        {t('price_calculator.label_pro.description')}
                                    </div>
                                    {!!errors?.adValoremTax && 
                                        <div className="error-container">
                                            <InfoIcon fill="#F8A0D2" />
                                            <div className="error-message">{t('price_calculator.step_3.error_message')}</div>
                                        </div>
                                    }
                                </div>
                                <div className='col-12 col-md-3 label-container container_input__pro'>
                                    <label className="label-input">{t('price_calculator.step_3.taxDeterminedByWeight.placeholder')}</label>
                                   
                                        <input
                                            type="text"
                                            className="price-calculator__textbox-general-col2"
                                            {...register('taxDeterminedByWeight', { required: true })}
                                            value={!!formThreeValues?.taxDeterminedByWeight ? formThreeValues?.taxDeterminedByWeight : ''}
                                            onChange={ (e) => {
                                                if (e.target.value === '' || numberRegex.test(e.target.value)) {
                                                    setFormThreeValues({...formThreeValues, taxDeterminedByWeight: formatNumber(e.target.value)})
                                                }
                                            }}
                                        />
                                    
                                    <div className="label__pro">
                                        <IconPro width={13} height={10} fill='#BBC2C7' />
                                        {t('price_calculator.label_pro.description')}
                                    </div>
                                    {!!errors?.taxDeterminedByWeight && 
                                        <div className="error-container">
                                            <InfoIcon fill="#F8A0D2" />
                                            <div className="error-message">{t('price_calculator.step_3.error_message')}</div>
                                        </div>
                                    }
                                </div>
                            </div>
                            
                            <div className="row price-calculator__row mb-4">
                                
                                    <div className="col-12 col-sm-12 col-md-6">
                                            
                                            <select
                                                {...register('importerCity', { required: true })}
                                                value={formThreeValues?.importerCity || ''} // Valor controlado del select
                                                onChange={(e) => {
                                                    const selectedPais = e.target.value;
                                                    
                                                    setFormThreeValues({
                                                        ...formThreeValues,
                                                        importerCity: selectedPais,
                                                    });
                                                }}
                                                className={`price-calc__dropdown-general price-calculator__select-font ${errors?.importerCity ? 'error' : ''}`}
                                            >
                                                <option value="" disabled>
                                                    {t('price_calculator.step_3.importerCity.placeholder') || 'Seleccionar Ciudad'}
                                                </option>

                                                {formThreeValues?.countryDestinationName &&
                                                Array.isArray(PaisesDestino[formThreeValues.countryDestinationName]) &&
                                                PaisesDestino[formThreeValues.countryDestinationName].map((city) => (
                                                    <option key={city} value={city}>
                                                        {city}
                                                    </option>
                                                ))}
                                            </select>
                                            
                                            {!!errors?.importerCity && (
                                                <div className="error-container">
                                                    <InfoIcon fill="#F8A0D2" />
                                                    <div className="error-message">{t('price_calculator.step_3.error_message')}</div>
                                                </div>
                                            )}
                                        </div>
                                    

                                <div className="col-12 col-sm-12 col-md-6">
                                <div className="price-calculator__distance">

                                    <div className='price-calculator__field-with-icon label-container container_input__pro'>
                                        <label className="label-input">{t('price_calculator.step_3.costTransportationPortWarehouse.placeholder')}</label>
                                        <input
                                            type="text"
                                            className="price-calculator__textbox-general-col2"
                                            {...register('costTransportationPortWarehouse', { required: true })}
                                            value={!!formThreeValues?.costTransportationPortWarehouse ? formThreeValues?.costTransportationPortWarehouse : ''}
                                            onChange={ (e) => {
                                                if (e.target.value === '' || numberRegex.test(e.target.value)) {
                                                    setFormThreeValues({...formThreeValues, costTransportationPortWarehouse: formatNumber(e.target.value)})
                                                }
                                            }}
                                        />

                                        <div style={{ marginLeft: "8px"}}>
                                            <CustomToolTip
                                                title=""
                                                tooltipText={t('price_calculator.step_3.costTransportationPortWarehouse.tooltip')}
                                            >
                                            <FontAwesomeIcon
                                                icon={faCircleQuestion}
                                                className="font-size: 18px"
                                            />
                                            </CustomToolTip>
                                        </div>
                                    </div>
                                    <div className="label__pro">
                                        <IconPro width={13} height={10} fill='#BBC2C7' />
                                        {t('price_calculator.label_pro.description')}
                                    </div>
                                    {(!!errors?.distance || !!errors?.costTransportationPortWarehouse) && 
                                        <div className="error-container">
                                            <InfoIcon fill="#F8A0D2" />
                                            <div className="error-message">{t('price_calculator.step_3.error_message')}</div>
                                        </div>
                                    }
                                    </div>
                                </div>
                                
                            </div>

                            {state?.isAuthenticated && remainingCalcs && remainingCalcs.remaining > 0 && (
                                <div className="row price-calculator__row mb-4">
                                <div className="col-12 col-sm-12 col-md-6">
                                
                                    <div className="price-calculator__distance">

                                        <div className='price-calculator__field-with-icon label-container container_input__pro'>
                                            <select
                                            {...register('importerTruckType', { required: true })}
                                            value={formThreeValues?.importerTruckType || ''} // Valor controlado del select
                                            onChange={(e) => {
                                                const selectedCamion = e.target.value;
                                                setFormThreeValues({
                                                    ...formThreeValues,
                                                    importerTruckType: selectedCamion,
                                                });
                                            }}
                                            className={`price-calc__dropdown-general price-calculator__select-font ${errors?.importerTruckType ? 'error' : ''}`}
                                        >
                                            <option value="" disabled>
                                            {t('price_calculator.step_3.camionAduana.placeholder')}
                                            </option>

                                            {Object.entries(truckTypeOptions[0] || {}).map(([key, value]: [string, { es: string; en: string; hi: string }]) => {
                                                const lang = i18n.language as 'es' | 'en' | 'hi';
                                                console.log('Rendering truck option:', { key, value, lang, currentValue: value[lang] });
                                                return (
                                                    <option key={key} value={key}>
                                                        {value[lang] || key}
                                                    </option>
                                                );
                                            })}
                                            </select>

                                            <div style={{ marginLeft: "8px"}}>
                                                <Tooltip
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setTooltipOpen(!tooltipOpen);
                                                    }}
                                                    open={tooltipOpen}
                                                    onClose={() => setTooltipOpen(false)}
                                                    disableHoverListener
                                                    disableFocusListener
                                                    disableTouchListener
                                                    classes={{ tooltip: "custom-tooltip" }}
                                                    title={
                                                        <React.Fragment>
                                                            <div dangerouslySetInnerHTML={{ __html: t('price_calculator.step_3.camionAduana.tooltip') }} />
                                                        </React.Fragment>
                                                    }
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faCircleQuestion}
                                                        className="font-size: 18px"
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                      
                                        {(!!errors?.importerTruckType ) && 
                                            <div className="error-container">
                                                <InfoIcon fill="#F8A0D2" />
                                                <div className="error-message">{t('price_calculator.step_3.error_message')}</div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                </div>
                                )}
                        </div>
                    </div>
                    <div className="price-calculator__container-footer">
                        <div
                            className="price-calculator__footer-link"
                            onClick={handleClickOpen}
                        >{t('price_calculator.footer.link')}</div>
                        <button type="submit" className="price-calc__next">
                            <div className="btn-test-next-text">{t('price_calculator.footer.button')}</div>
                            <FontAwesomeIcon icon={faArrowRight} color="black" />
                        </button>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default PriceCalculatorStepThree